import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";
import routerConfig from '../../../config/router';

import "./Logo.scss";

const Logo = (props) => {

  return (
    <div className="logo">

      <button
        className="logo__button"
        onClick={() => {
          props.history.push(routerConfig.home)
        }}
      >
        <picture>
          <source media="(max-width: 768px)" srcSet="/assets/img/logo-mob.png" />
          <img  src="/assets/img/logo.png" alt="Logo" />
        </picture>
        <p className="logo__sub-title">Your Virtual DMC partner</p>
      </button>
    </div>
  )
};

// Find Your Best Trip
Logo.propTypes = {
  history: PropTypes.object
};


export default withRouter(Logo);



// WEBPACK FOOTER //
// ./src/app/containers/Header/components/Logo.js